// TODO:custom dark theme
import { createTheme } from "@mui/material/styles"

const darkTheme = createTheme({})

export default darkTheme
